import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import JoinTheBetaMovement from "./sections/JoinTheBetaMovement";
import OurCreativeDna from "./sections/OurCreativeDna";
import StudioCapabilities from "./sections/StudioCapabilities";
import EarlyAccessBuzz from "./sections/EarlyAccessBuzz";
import ReadyToCreate from "./sections/ReadyToCreate";
import StudioFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <JoinTheBetaMovement />
      <OurCreativeDna />
      <StudioCapabilities />
      <EarlyAccessBuzz />
      <ReadyToCreate />
      <StudioFooter />
    </div>;
}